/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import createAsyncMutation from '../../utils/generators'

// Initial state
const state = {
  status: null,
  error: null,
  currentUser: {}
}

// Getters
const getters = {
  currentUser: state => state.currentUser,
  isStaff: state => state.currentUser.is_staff
}

// Mutations
const mutations = {
  GET_USER_PENDING(state) {
    state.status = 'loading'
  },
  GET_USER_SUCCESS(state, user) {
    state.status = 'success'
    state.currentUser = user.data
  },
  GET_USER_FAILURE(state) {
    state.status = 'error'
  },
  CLEAR_CURRENT_USER(state) {
    state.status = null
    state.currentUser = {}
  }
}

// Actions
const actions = {
  getUser: ({ dispatch, rootState }) => {
    const url = `${rootState.api.host}/${rootState.api.endpoints.user}/`
    const mutationTypes = createAsyncMutation('GET_USER')
    return dispatch('fetch', { url, mutationTypes }).catch(error => Promise.reject(error))
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/users.js